<template>
  <div
    v-if="isVisible"
    v-tooltip="tooltip && { placement: 'top', customClass: 'tooltip-current-time-line' }"
    class="current-time-line debug-tooltip"
    :title="tooltip"
    :style="{ left: position + '%', pointerEvents: 'auto' }"
  ></div>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const REFRESH_INTERVAL = 60 * 1000; // 1 minute

export default {
  name: 'InsightsCurrentTimeLine',
  props: {
    timeZone: {
      type: String,
      required: true,
    },
    tooltip: {
      type: [String, Boolean],
      default: false,
    },
  },
  data() {
    return {
      position: null,
      intervalId: null,
    };
  },
  computed: {
    isVisible() {
      return this.position !== null;
    },
  },
  watch: {
    timeZone() {
      this.updatePosition();
    },
  },
  mounted() {
    this.updatePosition();
    this.intervalId = setInterval(this.updatePosition, REFRESH_INTERVAL);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    updatePosition() {
      const totalMinutes = 24 * 60;
      const now = dayjs().tz(this.timeZone);
      const minutesSinceStart = now.hour() * 60 + now.minute();
      const percent = (minutesSinceStart / totalMinutes) * 100;

      // Wrap around 100%
      this.position = Number((percent % 100).toFixed(2));
    },
  },
};
</script>
